/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.buying.rpc.PublicDirectToBuyRpc
 */

export const createDirectToBuyConfigRpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicDirectToBuyRpc',
  rpcName: 'createDirectToBuyConfig',
  auth: 'external',
  fingerprint: 'zQRL67kZOeeA1hXn2coGG5hL_Uso95rB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};
export const getDirectToBuyConfigV2Rpc = {
  serviceName: 'com.hubspot.buying.rpc.PublicDirectToBuyRpc',
  rpcName: 'getDirectToBuyConfigV2',
  auth: 'external',
  fingerprint: 'RwkVwEpJCiZJYnad7bV2eJhL_Uso95rB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
  routingLocality: 'GLOBAL'
};